import { titulosApi } from "../view/titulos.service";

export const putTitulo = titulosApi.injectEndpoints({
  endpoints: (builder) => ({
    putTitulo: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/v1/api/titulo/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: (result, error, { id }) =>
        result
          ? [
              { type: "Titulos", id },
              { type: "Titulos", id: "LIST" },
            ]
          : [{ type: "Titulos", id: "LIST" }],
    }),
  }),
});

export const { usePutTituloMutation } = putTitulo;
